import Service from "./Service";
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export class LabelService extends Service{
    constructor() {
        super();
        this.baseURL = 'label';
    }

    findBySubcategoryId(subcategoryId) {
        return fetch(SERVER_URL + this.baseURL + '/findBySubcategoryId/' + subcategoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}